<template>
<div>
        <v-row no-gutters>
            <v-spacer/>
            <span style="width: 200px;" class="ma-2">
                    <v-autocomplete 
                         v-model="payment_type"
                        :items="types"
                    />
            </span>
        </v-row>
        <v-data-table
        :headers="headers"
        dense
        class="va-table"
        :items="SUMMARIESDATA"
        :items-per-page="10000"
        hide-default-footer
        >
         <template v-slot:body="{ items }">
            <tbody>
                <tr v-for="(item,index) in items" :key="index">          
                        <td class="text-xs-left">{{ item.customer }}</td>
                         <td class="text-xs-left">{{ item.customer_type }}</td>
                         <td class="text-right">{{ $money(item.amount) }}</td>
                         <td class="text-right">{{ $money(item.service_charge) }}</td>
                         <td class="text-right">{{ $money(item.trucking_fee) }}</td>
                         <td class="text-right">{{ $money($IsNum(item.amount) + $IsNum(item.service_charge) + $IsNum(item.trucking_fee)) }}</td>
                </tr>
            </tbody>
               <tfoot >
                <tr class="font-weight-bold" >          
                    <td class="text-left" style="border-top: 1px solid #212121;">TOTAL</td>
                    <td class="text-right" style="border-top: 1px solid #212121;"></td>
                    <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(AMOUNT) }}</td>
                    <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(SERVICE_CHARGE) }}</td>
                    <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(TRUCKING) }}</td>
                    <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(TOTAL) }}</td>
                </tr>
                
            </tfoot>
        </template>
        </v-data-table>
</div>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    selected_date: {
        type: String,
        default: ''
    }
  },
   data: () => ({
      summaries: [],
      formated_summaries:[],
      payment_type: "ALL",
      types:["ALL","CASH", "CREDIT"],
      headers: [
            { text: 'Customer'},
            { text: 'Type', sortable: false},
            { text: 'Amount', align:"right" , sortable: false},
            { text: 'Service Charge', align:"right" , sortable: false},
            { text: 'Trucking', align:"right" , sortable: false},
            { text: 'Total', align:"right" , sortable: false}
      ]
  }),
  created(){
       this.getItems()
  },
  computed:{
     AMOUNT(){
           var arr = this.SUMMARIESDATA
           let total = arr.reduce((a, o) => a += this.$IsNum(o.amount), 0)
           return total
      },
      TRUCKING(){
           var arr = this.SUMMARIESDATA
           let total = arr.reduce((a, o) => a += this.$IsNum(o.trucking_fee), 0)
           return total
      },
      SERVICE_CHARGE(){
           var arr = this.SUMMARIESDATA
           let total = arr.reduce((a, o) => a += this.$IsNum(o.service_charge), 0)
           return total
      },
      TOTAL(){
          return this.AMOUNT + this.TRUCKING + this.SERVICE_CHARGE
      },
        SUMMARIESDATA(){
            var arr =this.formated_summaries
            if(this.payment_type == "ALL") {
                return arr
            } 
            let type = "credit"
            if(this.payment_type == "CASH"){type='cash'}

             let collections =  arr.reduce((res, item) =>{
                    if(item.customer_type ==type) {
                        res.push(item)
                    }
                    return res
                }, [])
              return collections
        }
  },
  methods: {
       getItems: function() {
         this.summaries = []
            this.$http.post("transaction/query_payments", {account_type: 3, start_date: this.selected_date, end_date: this.selected_date}).then(response => {
                  response.data.data != null?this.summaries = response.data.data: this.summaries = []
                  this.FormatData()
          }).catch(e => {
           console.log(e.data)
         })
      },
      FormatData() {
          var header = [] //['customer', 'amount', 'service_charge', 'trucking_fee']
          for(var i=0;i<this.summaries.length;i++) {
                if(this.summaries[i].type == 4) {
                        header.push(
                            {
                            type: this.summaries[i].type,
                            customer: this.summaries[i].customer,
                            customer_type: this.summaries[i].credit=='enabled'?'credit':'cash',
                            amount: this.summaries[i].amount,
                            service_charge: 0,
                            trucking_fee: 0,
                            trans_date: this.summaries[i].trans_date
                            }
                        )
                }
                if(this.summaries[i].type == 5) {
                        header.push(
                            {
                            type: this.summaries[i].type,
                            customer: this.summaries[i].customer,
                            customer_type: this.summaries[i].credit=='enabled'?'credit':'cash',
                             amount:0,
                            service_charge: this.summaries[i].amount,
                            trucking_fee: 0,
                            trans_date: this.summaries[i].trans_date
                            }
                        )
                }
                if(this.summaries[i].type == 6) {
                        header.push(
                            {
                            type: this.summaries[i].type,
                            customer: this.summaries[i].customer,
                            customer_type: this.summaries[i].credit=='enabled'?'credit':'cash',
                             amount:0,
                            service_charge: 0,
                            trucking_fee: this.summaries[i].amount,
                            trans_date: this.summaries[i].trans_date
                            }
                        )
                }
          }
        var groupBy = this.$groupBy('customer')
        var data = groupBy(header)
        let entries = Object.entries(data)
        let returndata = []
        for (const [customer, items] of entries) {
            returndata.push(this.total_amount(customer, items))
        }
        this.formated_summaries = returndata
      },
      total_amount(customer, arr){
            var amount = 0
            var service_charge = 0
            var trucking_fee = 0
            var customer_type = ''
            for(var i = 0;i<arr.length;i++) {
                customer_type = arr[i].customer_type
                if(arr[i].type==4) {
                    amount +=this.$IsNum(arr[i].amount)
                }
                if(arr[i].type==5) {
                    service_charge +=this.$IsNum(arr[i].service_charge)
                }
                if(arr[i].type==6) {
                    trucking_fee +=this.$IsNum(arr[i].trucking_fee)
                }
            }
            return {customer:customer,customer_type:customer_type, amount:amount, service_charge:service_charge, trucking_fee:trucking_fee}
      }
  }
}
</script>
